__turbopack_context__.v({
  "className": "myriadpro_a3f51303-module__XiArEW__className",
  "variable": "myriadpro_a3f51303-module__XiArEW__variable",
});
